import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Table, Row,Col } from 'antd';
import { Scrollbars } from 'react-custom-scrollbars-2';
import MobileCallHistoryWrapper from './styles/m-callhistory.style';


const users = [
	{
		id:1,
		from:'1:38 PM',
		to:'2:38 PM',
		name:'Maria Janes',
		date:'Thu, Jun 18 2020',
		totalduration:'01:00'
	},
	{
		id:2,
		from:'1:38 PM',
		to:'2:38 PM',
		name:'Maria Janes and 3 more',
		date:'Thu, Jun 18 2020',
		totalduration:'01:00'
	},
	{
		id:3,
		from:'1:38 PM',
		to:'2:38 PM',
		name:'Jane Smith and 2 more',
		date:'Thu, Jun 18 2020',
		totalduration:'01:00'
	},
	{
		id:4,
		from:'1:38 PM',
		to:'2:38 PM',
		name:'Maria Janes and 3 more',
		date:'Thu, Jun 18 2020',
		totalduration:'01:00'
	},
	{
		id:5,
		from:'1:38 PM',
		to:'2:38 PM',
		name:'Jane Smith and 2 more',
		date:'Thu, Jun 18 2020',
		totalduration:'01:00'
	},
	{
		id:6,
		from:'1:38 PM',
		to:'2:38 PM',
		name:'Jane Smith and 2 more',
		date:'Thu, Jun 18 2020',
		totalduration:'01:00'
    },
    
]

const users1 = [
	{
		id:1,
		name:'Maria Janes',
		from:'1:38 PM',
		to:'2:38 PM',
	},
	{
		id:2,
		name:'Maria Janes and 3 more',
		from:'1:38 PM',
		to:'2:38 PM',
	},
	{
		id:3,
		name:'Jane Smith and 2 more',
		from:'1:38 PM',
		to:'2:38 PM',
	}
]


class CallHistory extends Component {
	constructor(props) {
		super(props);
		this.state={
			showFooter:false,
			showLoader:false,
			showCallSummary:false,
			showCallDetail:false,
			noDetails:false,
			emptycallHistory:true,
			
		}
	}
	loadMore = () =>{
			this.setState({
				showFooter:false,
				showLoader:true
		})
	}
	componentDidMount(){
		const len = users.length;
		if(len < 5){
			this.setState({
				showFooter:false
			})
		}
		else{
			this.setState({
				showFooter:true
			})	
		}
	}
	itemClick = (index) =>{
		this.setState({
			activeIndex:index,
			showCallSummary:false,
			showCallDetail:true
		})
	}

	openCallSummary = () =>{
		this.setState({
		showCallSummary:true,
		showCallDetail:false
	})	
	}
	
	render() {
		const { therapists, searchText, handleInputChange } = this.props;
		let callHistory = therapists.callHistory;
		
		if(searchText !== ""){
			callHistory = callHistory.filter(call => call.patient.toLowerCase().indexOf(searchText.toLowerCase()) !== -1);
		}

		return (
		<MobileCallHistoryWrapper>
		<section className="callHistory">
        <div className="tableFilters pl-15 pr-15">
        <div className="searchEntries">
		<label>call history</label>
		<input type="text" placeholder="Search" onChange={(evt) => handleInputChange(evt.target.value)} />
         </div>
        </div>
		<div className="callHistory-box">
			<Row>
			<>
			{this.state.showCallSummary &&
				<Col span={24}>
				<div className="callhistory-summary card-panel">
					<Scrollbars>
					<div className="scrollable-content">
					{users.map((user, index) => { 
						return(
						<div key={index} className={this.state.activeIndex === index ? 'listItem rightarrow active' : 'listItem rightarrow'} onClick={() => this.itemClick(index)}>
							<Row>
									<Col xs={{ span: 12}} lg={{ span: 16 }}>
										<div className="col">
											<h1>{user.name}</h1>
											<div className="duration">
												<h2>{user.from}</h2>
												<span><img src="/images/arrow-right@2x.png" width="10" /></span>
												<h2>{user.to}</h2>
											</div>
										</div>
									</Col>
									<Col xs={{ span: 12}} lg={{ span: 8}}>
										<div className="col pr-30 text-right">
											<h3>{user.date}</h3>
											<div className="totalDuration">
												<span><img src="/images/clock@2x.png" width="10" /></span>
												<h4>{user.totalduration}</h4>
											</div>
										</div>
									</Col>
							</Row>
						</div>
						)})}
					</div>
					</Scrollbars>
					{this.state.showFooter &&
					<footer>
						<button className="load-more-btn" onClick={this.loadMore}>load more</button>
					</footer>
					}
					{this.state.showLoader &&
					<footer>
					<div className="history-loader">
						<div className="loader-icon"></div>
					</div>
					</footer>
					}
				</div>
				</Col>
				}
				{this.state.emptycallHistory &&
				<Col span={24}>
				<div className="callhistory-summary card-panel autobox">
				<h1>Your call history is empty.</h1>
				</div>
				</Col>
				}
				</>
				{this.state.showCallDetail &&
				<Col xs={{span:24}} lg={{span:15}}>
				<div className="callhistory-detail card-panel">
				
				<div className="listItem no-border">
						<Row>
								<Col xs={{span:24}} lg={{span:24}}>
									<div className="back-btn" onClick={this.openCallSummary}>
									<img src="/images/arrow-back.png" width="15" />
									<h2>Back</h2>
									</div>
								</Col>
						</Row>
						<Row>
								<Col xs={{span:13}} lg={{span:18}}>
									<div className="col">
										<h5>Name</h5>
									</div>
								</Col>
								<Col xs={{span:11}} lg={{span:6}}>
								<div className="col">
									<div className="right-title">
										<h5>Join & Leave Time</h5>
									</div>
									</div>
								</Col>
						</Row>
					</div>
					<Scrollbars>
					<div className="scrollable-content">
					{users1.map((user, index) => { 
						return(
								<div key={index} className="listItem">
									<Row>
									<Col xs={{ span: 13 }} lg={{ span: 18 }} >
												<div className="col">
													<h1>{user.name}</h1>
												</div>
											</Col>
											<Col xs={{ span: 11 }} lg={{ span: 6 }}>
												<div className="col text-right">
												<div className="duration">
														<h2>{user.from}</h2>
														<span><img src="/images/arrow-right@2x.png" width="10" /></span>
														<h2>{user.to}</h2>
													</div>
												</div>
											</Col>
									</Row>
								</div>
								)
							})
						}
					</div>
					</Scrollbars>
				</div>
				</Col>
				}
			</Row>
		</div>
		</section>
      </MobileCallHistoryWrapper>
		  ) 
	}
}

export default connect(
	state => state
)(CallHistory);

